import { useState } from "react"
import { Button } from "@/components/ui/button"
import { LoginModal } from "@/features/auth/components/LoginModal"
import { getAssetUrl } from "@/utils/assets"

interface SignInCTACardProps {
  variant?: "default" | "followers" | "comments"
  className?: string
}

export function SignInCTACard({ variant = "default", className = "" }: SignInCTACardProps) {
  const [showLoginModal, setShowLoginModal] = useState(false)

  const messages: Record<string, { title: string; subtitle: string }> = {
    default: {
      title: "Sign in to see more",
      subtitle: "Join Rituality to unlock full access",
    },
    followers: {
      title: "See who's part of this circle",
      subtitle:
        "Join to explore all members, connect with like-minded people, and become part of the community",
    },
    comments: {
      title: "Sign in to join the conversation",
      subtitle: "Sign in to share your thoughts and engage with the community.",
    },
  }

  const { title, subtitle } = messages[variant] || messages.default

  const private_account = getAssetUrl("private_account.svg")

  return (
    <>
      <div
        className={`flex flex-col md:flex-row gap-3.75 items-center justify-between p-5 rounded-[10px] mb-5 bg-[#C9A8761A] border border-[#C9A8761A] ${className}`}
      >
        <div className="flex flex-col md:flex-row items-center gap-3.75">
          <div className="bg-[#C9A87626] p-3.75 rounded-full min-w-[55px] min-h-[55px]">
            <img src={private_account} alt="" className="w-6.25 h-6.25" />
          </div>
          <div className="flex flex-col items-center md:items-start gap-1.25">
            <h3 className="text-[16px] font-semibold text-primary text-center md:text-start leading-5">
              {title}
            </h3>
            <p className="text-sm text-primary/90 text-center md:text-start">{subtitle}</p>
          </div>
        </div>
        <div className="flex gap-3">
          <Button
            variant="outline"
            size="sm"
            onClick={() => setShowLoginModal(true)}
            className="rounded-full px-6 w-[210px] h-[50px] py-3.75"
          >
            Sign In
          </Button>
        </div>
      </div>
      <LoginModal open={showLoginModal} onOpenChange={setShowLoginModal} />
    </>
  )
}
